import { render, staticRenderFns } from "./DataCard.vue?vue&type=template&id=3fa2c082&scoped=true"
import script from "./DataCard.vue?vue&type=script&lang=js"
export * from "./DataCard.vue?vue&type=script&lang=js"
import style1 from "./DataCard.vue?vue&type=style&index=1&id=3fa2c082&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa2c082",
  null
  
)

export default component.exports